<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <b-row class="justify-content-between px-1 align-items-center">
          <div class="d-flex align-items-center w-50">
            <h3 class="w-50">جدول المنظمات</h3>

            <b-input-group dir="rtl" class="input-group-merge">
              <b-form-input
                v-model="searchKey"
                placeholder="أدخل اسم المنظمة أو جزء منه ..."
              />
              <b-input-group-append is-text>
                <feather-icon
                  v-if="searchKey.length > 0"
                  class="cursor-pointer"
                  @click="searchKey = ''"
                  icon="XIcon"
                />
                <feather-icon v-else icon="SearchIcon" />
              </b-input-group-append>
            </b-input-group>
          </div>

          <b-button
            v-can="{ slug: $route.meta.slug, action: 'C' }"
            @click="
              type = 'ADD';
              ngoModal = true;
              imagePreview = null;
            "
            variant="success"
            >إضافة</b-button
          >
        </b-row>
        <hr />
        <data-table
          id="ngos-table"
          :ep.sync="ep"
          :fields="fields"
          ref="ngosTable"
        >
          <template #cell(actions)="{ item }">
            <b-dropdown
              variant="link"
              no-caret
              :left="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-can="{ slug: $route.meta.slug, action: 'U' }"
                @click="onEditClicked(item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">تعديل</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                @click="onDeleteClicked(item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">حذف</span>
              </b-dropdown-item>
            </b-dropdown></template
          >
        </data-table>
      </div>
    </b-card>
    <form-modal
      ref="ngoForm"
      title="معلومات المنظمة"
      :loading="working"
      :formSchema="ngoFormSchema"
      v-model="ngoModal"
      @confirm="onConfirm"
    >
    </form-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BButton,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapActions, mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormFile from "@/components/form-file/index.vue";
import FormInput from "@/components/form-input/index.vue";
import DataTable from "@/components/data-table";
import debounce from "lodash.debounce";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    MinistryBreadcrumbs,
    FormModal,
    FormFile,
    BCardText,
    FormInput,
    FormInput,
    DataTable,
  },

  data() {
    return {
      mainTitle: "إدارة المنظمات",
      ngoModal: false,
      type: "ADD",
      searchKey: "",
      ep: "v2/ministry/immediate-ngos",
      ngoFormSchema: {
        source: {
          key: "source",
        },

        name_ar: {
          component: "FormInput",
          key: "name_ar",
          attrs: {
            label: "الاسم",
            rules: "required",
          },
        },
        legal_form_id: {
          component: "FormSelect",
          key: "legal_form_id",
          attrs: {
            label: "الشكل القانوني ",
            id: "legal_form",
            ep: "v2/ministry/selects/legal-forms",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
          },
        },
        hq_id: {
          component: "FormSelect",
          key: "hq_id",
          attrs: {
            label: "محافظة المقر ",
            id: "hq-gov",
            ep: "v2/ministry/selects/governorates",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
          },
        },
        status_id: {
          component: "FormSelect",
          key: "status_id",
          attrs: {
            label: "حالة المنظمة ",
            id: "ngo-status",
            ep: "v2/ministry/selects/ngo-status",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
          },
        },
        decision_no: {
          component: "FormInput",
          key: "decision_no",
          attrs: {
            label: "رقم قرار الإشهار",
            rules: "required",
          },
        },
        decision_date: {
          component: "FormMask",
          key: "decision_date",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ قرار الإشهار",
            rules: "required",
          },
        },
      },
      fields: [
        { label: "المعرف", key: "id" },
        { label: "الاسم", key: "name_ar" },
        { label: "الشكل القانوني", key: "legalForm.name_ar" },
        { label: "محافظة المقر", key: "hq.name_ar" },
        { label: "حالة المنظمة", key: "status.name_ar" },
        { label: "رقم قرار الإشهار", key: "decision_no" },
        { label: "تاريخ قرار الإشهار", key: "decision_date" },
        { label: " ", key: "actions" },
      ],
      breadcrumbs: [
        // {
        //   text: "الإعدادات",
        //   to: "/ministry/settings",
        // },
        {
          text: "إدارة المنظمات",
          to: "/ministry/ngos-communication",
        },
        {
          text: "جدول المنظمات",
          active: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters("Ministry/Settings/NgosManagement", ["working"]),
  },
  watch: {
    searchKey: debounce(function (value) {
      this.ep = "v2/ministry/immediate-ngos?search=" + value;
      this.$refs.ngosTable.refreshTable();
    }, 300),
  },
  methods: {
    ...mapActions("Ministry/Settings/NgosManagement", [
      "editNgo",
      "addNgo",
      "deleteNgo",
    ]),

    async onConfirm(form) {
      if (form.id) {
        await this.editNgo(form).then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تم تعديل السجل بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
              timeout: 3000,
            },
          });
        });
      } else {
        if(form.legal_form_id === 1)
          form.members_type = false
        else
          form.members_type = true
        
        await this.addNgo(form).then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تمت إضافة السجل بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
              timeout: 3000,
            },
          });
        });
      }
      this.ngoModal = false;

      this.$refs.ngosTable.refreshTable();
    },

    onEditClicked(form) {
      this.type = "EDIT";
      var toEdit = { ...form };
      toEdit.legal_form_id = form.legalForm.id;
      toEdit.status_id = form.status.id;
      toEdit.hq_id = form.hq ? form.hq.id : null;

      delete toEdit.legalForm;
      delete toEdit.status;
      delete toEdit.hq;
      this.$refs.ngoForm.init(toEdit);
      this.ngoModal = true;
    },
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المنظمة ؟", {
          title: "تأكيد حذف المنظمة",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteNgo(id);
            this.$refs.ngosTable.refreshTable();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "تم حذف السجل بنجاح",
                icon: "CheckSquareIcon",
                variant: "success",
                timeout: 3000,
              },
            });
          }
        });
    },
  },
};
</script>
